// Rules use ISO weekdays (Monday=1). Null is explicitly unlimited; absence inherits.
export function effectiveDailyMatchLimit(config, date) {
  const exception = (config.date_match_limits || []).find((rule) => rule.date === date);
  if (exception) return { limit: exception.max_matches, source: "date" };
  const weekday = new Date(`${date}T12:00:00Z`).getUTCDay() || 7;
  const weekly = (config.weekday_match_limits || []).find((rule) => Number(rule.weekday) === weekday);
  if (weekly) return { limit: weekly.max_matches, source: "weekday" };
  return { limit: config.max_matches_per_day_per_player ?? null, source: "general" };
}

export function updateDailyMatchRule(rules, key, value, selected) {
  const remaining = (rules || []).filter((rule) => String(rule[key]) !== String(value));
  if (selected === "inherit") return remaining;
  return [...remaining, { [key]: value, max_matches: selected === "unlimited" ? null : Number(selected) }]
    .sort((a, b) => String(a[key]).localeCompare(String(b[key])));
}

export function isValidRuleDate(date) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return false;
  const parsed = new Date(`${date}T12:00:00Z`);
  return !Number.isNaN(parsed.getTime()) && parsed.toISOString().slice(0, 10) === date;
}
